'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var jsUtils = require('@swiggy-private/js-utils');
var SpriteIconWeb_styled = require('./styled.js');
require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SpriteIconWeb = ({ iconName, ariaLabel, strokeColor = "text_Highest_Emphasis", fillColor = "text_Highest_Emphasis", height, width, style, basePath = "", }) => {
    var _a;
    const isDecorative = React.useMemo(() => jsUtils.isEmpty(ariaLabel), [ariaLabel]);
    const dim = ((_a = iconName.match(/\d+$/)) === null || _a === void 0 ? void 0 : _a[0]) || "20";
    return (React__default['default'].createElement(SpriteIconWeb_styled.StyledSprite, { "aria-label": ariaLabel, "aria-hidden": isDecorative, strokeColor: strokeColor, fillColor: fillColor, height: height || dim, width: width || dim, style: style },
        React__default['default'].createElement("use", { xlinkHref: `${basePath}/core/sprite-cc704d40.svg#${iconName}` })));
};

exports.SpriteIconWeb = SpriteIconWeb;
//# sourceMappingURL=index.js.map
